// TODO fix accessibility issues

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */
import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { memo } from 'react';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { sendEvent } from 'lib/gtag';

const ListItemTitle = ({
  gaEventCategory,
  href,
  title = null,
  titleType = null,
}) => {
  const onTitleClick = () =>
    sendEvent({
      category: gaEventCategory,
      action: `click_title_${
        (titleType === 'ARTICLE' && 'blog') ||
        (titleType === 'THREAD' && 'forum')
      }`,
    });

  if (!title || !titleType) {
    return null;
  }

  return (
    <NextLink href={href} prefetch={false} passHref>
      <a
        className="mb-4 flex w-full flex-row justify-between bg-neutral-high-200 px-4 py-2 dark:bg-neutral-low-300"
        onClick={onTitleClick}
      >
        <div className="md:flex">
          <Text className="whitespace-nowrap">
            Comentou no{' '}
            {(titleType === 'ARTICLE' && 'blog') ||
              (titleType === 'THREAD' && 'tópico')}
            :
          </Text>
          <Text className="mr-4 line-clamp-2 md:ml-1 md:line-clamp-1" bold>
            {title}
          </Text>
        </div>
        <Icon
          className="text-neutral-low-500 dark:text-neutral-high-100"
          name="link-blank"
        />
      </a>
    </NextLink>
  );
};

ListItemTitle.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  titleType: PropTypes.oneOf(['ARTICLE', 'THREAD']),
};

export default memo(ListItemTitle);
